import { Col, Row, Space } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KPriceInfo from 'app/components/Modules/DataDisplay/KPriceInfo'
import React from 'react'

type Props = unknown

const DeliveryPrice: React.FC<MemberProps<IDeliveryItem, Props>> = ({ member }) => {
  return (
    <Row>
      <Col span={24}>
        <strong>
          <Space className="justify-content-between full-width">
            {member.name}
            <KPriceInfo member={member} props={{ type: 'span', rightElement: false }} />
          </Space>
        </strong>
      </Col>
      {member.cargos?.map((item, index) => (
        <Col span={24} key={`${item.name}-${index}`}>
          {item.name}
        </Col>
      ))}
    </Row>
  )
}

export default DeliveryPrice
